import React, { useContext } from 'react';
import { ReceiptListProvider } from '../context';
import ViewReceipt from './ViewReceipt.j';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import { RolePermissions } from 'appContext';
import { PermissionContext } from 'appContext';
import { pages } from 'views/pages/manage/common/constant';

const ViewReceiptWrapper=()=>{

    const userPermissions = RolePermissions(
        useContext(PermissionContext),
        pages["paymentCollectionManageReceipts"]["id"]
      );

    return userPermissions ? (
        <ReceiptListProvider>
          <ViewReceipt />
        </ReceiptListProvider>
      ) : (
        <PermisionDenied />
      );
}
export default ViewReceiptWrapper